import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "@repo/shared";
import App from "./App";

import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <BrowserRouter>
  <AuthProvider>
    <App />
    </AuthProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

reportWebVitals();